import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
    {
        url_id: "/list/kelola-nasabah/kelola-akun-direct-debit",
        url_path: "/list/kelola-nasabah/kelola-akun-direct-debit",
    },
    {
        url_id: "/list/kelola-nasabah/kelola-akun-direct-debit",
        url_path: "/form/kelola-nasabah/kelola-akun-direct-debit",
    },
    {
        url_id: "/list/persetujuan/kelola-akun-direct-debit",
        url_path: "/list/persetujuan/kelola-akun-direct-debit",
    },
    {
        url_id: "/list/persetujuan/kelola-akun-direct-debit",
        url_path: "/form/persetujuan/kelola-akun-direct-debit",
    },
    {
        url_id: "laporan/kelola-akun-direct-debit",
        url_path: "/laporan/kelola-akun-direct-debit",
    },
];
